// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__dt7DZ","messages":"Chat_messages__1xbcZ","dateDivider":"Chat_dateDivider__zDExw"};